import script from "./EventLists.vue?vue&type=script&setup=true&lang=js"
export * from "./EventLists.vue?vue&type=script&setup=true&lang=js"

import "./EventLists.vue?vue&type=style&index=0&id=f13a90dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f13a90dc"]])

export default __exports__